// extracted by mini-css-extract-plugin
export default {"textContainer":"TitleDesc_textContainer__MgGQh"};